<template>
  <el-card
    v-loading="isloading"
    class="history-voyage"
    shadow="never"
    :body-style="{ padding: '20px' }"
  >
    <div slot="header" class="clearfix">
      <span style="font-size: 16px">历史挂靠记录</span>

      <el-popover
        v-model="added.visible"
        placement="bottom"
        width="300"
        trigger="click"
        @show="added.ms = availableMmsi.join(',')"
      >
        <div style="padding: 15px">
          <el-form size="mini" label-position="right" label-width="50px">
            <el-form-item label="mmsi">
              <el-input
                v-model="added.ms"
                placeholder="mmsi"
                clearable
                style="width: 100%"
              />
            </el-form-item>

            <el-form-item label="时间">
              <el-date-picker
                v-model="added.begin"
                type="datetime"
                clearable
                style="width: 100%"
                placeholder="开始时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-form>

          <div style="text-align: right">
            <el-button
              size="mini"
              type="primary"
              :disabled="!avaliableAddedMs.length"
              :loading="added.loading"
              @click="addHistoryVoyage"
            >
              添加
            </el-button>
          </div>
        </div>

        <el-button
          slot="reference"
          type="text"
          size="small"
          style="margin-left: 15px"
        >
          刷新历史挂靠
        </el-button>
      </el-popover>

      <el-button
        type="text"
        size="small"
        style="margin-left: 15px"
        @click="refresh"
      >
        刷新
      </el-button>
    </div>

    <div>
      <el-input
        v-model="form.mmsi"
        placeholder="mmsi..."
        size="mini"
        style="width: 30%"
        clearable
      />
    </div>

    <el-table
      size="mini"
      :data="data"
      max-height="400"
      style="margin-top: 10px"
    >
      <el-table-column prop="mmsi" label="MMSI" />
      <el-table-column prop="minAta" label="最小ATA" />
      <el-table-column prop="maxAta" label="最大ATA" />
      <el-table-column prop="count" label="总数" align="right" width="90" />

      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="lookup(scope.row)">
            查看
          </el-button>
          <el-button
            size="mini"
            type="text"
            :loading="scope.row.loading"
            @click="updateHistoryVoyageRow(scope.row)"
          >
            更新
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="innerVoyageWin" append-to-body>
      <inner-voyage-table
        :mmsi="innerVoyageOpt.mmsi"
        :version="innerVoyageOpt.version"
      />
    </el-dialog>
  </el-card>
</template>

<script>
import { uniq, debounce } from 'lodash'

import dayjs from 'dayjs'

import api from './api'

import InnerVoyageTable from './InnerVoyageTable.vue'

const filterMmsi = ms => {
  if (ms) {
    const test = k => /^\d{9}$/.test(k)
    ms = uniq(ms.split(/\D/).filter(test))
    if (ms.length) {
      return ms
    }
  }
}

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

export default {
  components: {
    InnerVoyageTable,
  },

  mixins: [api],

  data() {
    this.empty = []

    const begin0 = dayjs().add(-1, 'year').format('YYYY-MM-DD')

    return {
      form: {
        mmsi: '',

        queryTime: '',
      },

      added: {
        ms: '',
        begin: begin0,
        loading: false,
        visible: false,
      },

      data: [],

      isloading: false,

      innerVoyageWin: false,

      innerVoyageOpt: {
        version: 0,
      },
    }
  },

  computed: {
    availableMmsi() {
      return filterMmsi(this.form.mmsi) || this.empty
    },

    avaliableAddedMs() {
      return filterMmsi(this.added.ms) || this.empty
    },
  },

  watch: {
    availableMmsi: 'refresh',
  },

  created() {
    this._queryHistoryVoyageStat0 = debounce(this.queryHistoryVoyageStat0, 500)
    this.queryHistoryVoyageStat0()
  },

  activated() {
    this.queryHistoryVoyageStat0()
  },

  methods: {
    refresh() {
      this._queryHistoryVoyageStat0(this.availableMmsi)
    },

    lookup(row) {
      this.innerVoyageOpt.mmsi = row.mmsi
      this.innerVoyageOpt.version++
      this.innerVoyageWin = true
    },

    async updateHistoryVoyageRow(row) {
      const { mmsi, maxAta } = row
      this.$set(row, 'loading', true)
      try {
        if (await this.updateHistoryVoyage([mmsi])) {
          this.refresh()
        }
      } finally {
        this.$set(row, 'loading', false)
      }
    },

    async queryHistoryVoyageStat0(ms) {
      this.isloading = true
      try {
        const resp = await this.queryHistoryVoyageStat(ms)
        if (resp.data.status === 1) {
          this.data = resp.data.content || []
        } else {
          this.data = []
        }
      } finally {
        this.isloading = false
      }
    },

    async updateHistoryVoyage(ms, begin) {
      const resp = await this.$api.get(
        '/trace/aiseventops/updateHistoryVoyage',
        {
          params: {
            mmsi: ms.join(','),
            begin: begin,
          },
          baseURL: '/',
        }
      )

      if (resp.data.status === 1) {
        // this.$message.success('已添加至更新队列中')
        return true
      } else {
        this.$message.error(resp.data.message || '更新历史挂靠错误')
      }
    },

    async addHistoryVoyage() {
      const ms = this.avaliableAddedMs

      if (!ms.length) {
        return this.$message.error('请输入mmsi')
      }

      if (
        !this.added.begin ||
        dayjs(this.added.begin, 'YYYY-MM-DD HH:mm:ss').isAfter(Date.now())
      ) {
        return this.$message.error('开始时间不能为空或大于当前时间')
      }

      this.added.loading = true

      try {
        if (await this.updateHistoryVoyage(ms, this.added.begin)) {
          this.refresh()
          this.added.visible = false
        }
      } finally {
        this.added.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.history-voyage {
  border: none;

  .mmsi-area {
    display: flex;
    flex-direction: row;
    align-items: center;

    .mmsi-input {
      flex-grow: 1;
    }

    .match-result {
      margin-left: 6px;
      font-size: 1.5em;

      &.match-result-loading {
        font-size: 1em;
      }

      &.match-result-success {
        color: #67c23a;
      }

      &.match-result-error {
        color: #f56c6c;
      }
    }
  }
}
</style>
